<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<v-card>
					<v-card-title primary-title>
						<v-icon primary left> mdi-menu </v-icon>
						<h4 class="ml-3">Changes</h4>
						<v-spacer></v-spacer>
						<v-btn class="primary">Save</v-btn>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-1 pr-0">Order Options</h2>
							<v-flex xs12 md12>
								<v-checkbox
									label="Enabled Order SMS Verification"
									color="primary"
									value="primary"
								></v-checkbox>
							</v-flex>

							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<v-row class="pt-3">
								<h4 class="pt-7 ml-4 pr-0">
									Customer can request sms code every
								</h4>
								<v-col cols="6" sm="2" md="2" class="pt=5 pl-4">
									<v-text-field solo dense></v-text-field>
								</v-col>
								<v-col cols="3" class="pl-0">
									<v-subheader
										>(Minutes) default is 5
										minute</v-subheader
									>
								</v-col>
							</v-row>
						</v-flex>
						<v-divider></v-divider>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-1 pr-0">Order Options</h2>
							<v-subheader
								>if item is not avalilable do the following
								actions</v-subheader
							>
							<v-flex xs12 md12>
								<v-radio-group v-model="ex8" column>
									<v-radio
										label="Dide"
										color="primary"
										value="primary"
									></v-radio>
									<v-radio
										label="Disabled"
										color="success"
										value="success"
									></v-radio>
									<v-radio
										label="Disabled food gallery"
										color="info"
										value="info"
									></v-radio>
									<v-radio
										label="Make menu private"
										color="warning"
										value="warning"
									></v-radio>
								</v-radio-group>
							</v-flex>

							<v-subheader
								>You can use this when you don't want to show
								yet your name menu in front end to preview the
								menu in front end
							</v-subheader>
						</v-flex>
						<v-divider></v-divider>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-1 pr-0">Two Flavor Options</h2>
							<v-row class="pt-6">
								<v-col cols="6" sm="4" md="4" class="pt=5 pl-4">
									<v-radio-group v-model="ex8" column>
										<v-radio
											label="Highest Price"
											color="primary"
											value="primary"
										></v-radio>
									</v-radio-group>
								</v-col>
								<v-col cols="6" sm="4" md="4" class="pt=5 pl-4">
									<v-radio-group v-model="ex8" column>
										<v-radio
											label="Sumpu and divide by 2"
											color="success"
											value="success"
										></v-radio>
									</v-radio-group>
								</v-col>
							</v-row>
							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-2 pr-0">Receipt Options</h2>
							<v-row class="pt-3">
								<v-col cols="12" sm="2" md="2">
									<h4 class="pt-5 ml-2 pr-0">Tax number</h4>
								</v-col>
								<v-col cols="12" sm="2" md="2">
									<v-text-field outlined dense></v-text-field>
								</v-col>
							</v-row>
							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-2 pr-0">Printing Options</h2>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-5 ml-2 pr-0">
										Receipt width
									</h4>
								</v-col>
								<v-col cols="12" sm="4" md="3">
									<v-text-field
										outlined
										suffix="px"
										dense
									></v-text-field>
								</v-col>
							</v-row>
							<v-row class="pt-0">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-5 ml-2 pr-0">Font Size</h4>
								</v-col>
								<v-col cols="12" sm="4" md="3">
									<v-text-field
										outlined
										suffix="px"
										dense
									></v-text-field>
								</v-col>
							</v-row>
							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-2 pr-0">
								Free Delivery Options
							</h2>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-5 ml-2 pr-0">
										Free Delivery Sub Total Order
									</h4>
								</v-col>
								<v-col cols="12" sm="4" md="3">
									<v-text-field
										suffix="$"
										dense
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-2 pr-0">Merchant Open/Close</h2>
							<v-flex xs12 md12>
								<v-checkbox
									label="Close Store?"
									color="primary"
									value="primary"
								></v-checkbox>
								<v-checkbox
									label="Show Merchant Current Time?"
									color="primary"
									value="primary"
								></v-checkbox>
								<v-checkbox
									label="Disabled Ordering?"
									color="primary"
									value="primary"
								></v-checkbox>
							</v-flex>

							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-1 pr-0">External Website</h2>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-5 ml-2 pr-0">
										Website address
									</h4>
								</v-col>
								<v-col cols="12" sm="8" md="6">
									<v-text-field
										outlined
										label="http://"
										dense
									></v-text-field>
								</v-col>
							</v-row>
							<v-flex xs12 md12>
								<v-checkbox
									label="Enabled Voucher?"
									color="primary"
									value="primary"
								></v-checkbox>
								<v-checkbox
									label="Make Delivery Time Requied?"
									color="primary"
									value="primary"
								></v-checkbox>
							</v-flex>

							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-2 pr-0">Order Delivery</h2>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-3 ml-2 pr-0">
										Minimun Order Delivery
									</h4>
									<h5 class="pt-4 ml-2 pr-0">
										Minimun purchase amount
									</h5>
								</v-col>
								<v-col cols="12" sm="4" md="3" class="pt-12">
									<v-text-field
										suffix="$"
										dense
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-divider></v-divider>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-0 ml-2 pr-0">
										Maximum Order Deliery
									</h4>
									<h5 class="pt-4 ml-2 pr-0">
										Maximum purchase amount
									</h5>
								</v-col>
								<v-col cols="12" sm="4" md="3" class="pt-10">
									<v-text-field
										suffix="$"
										dense
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-divider></v-divider>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-0 ml-2 pr-0">
										Minimum Order Pickup
									</h4>
									<h5 class="pt-4 ml-2 pr-0">
										Minimum purchase amount
									</h5>
								</v-col>
								<v-col cols="12" sm="4" md="3" class="pt-10">
									<v-text-field
										suffix="$"
										dense
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-divider></v-divider>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h4 class="pt-0 ml-2 pr-0">
										Maximum Order Pickup
									</h4>
									<h5 class="pt-4 ml-2 pr-0">
										Maximum purchase amount
									</h5>
									<v-subheader> </v-subheader>
								</v-col>
								<v-col cols="12" sm="4" md="3" class="pt-10">
									<v-text-field
										suffix="$"
										dense
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-divider></v-divider>
						</v-flex>
						<v-flex xs12 md12>
							<h2 class="pt-7 ml-2 pr-0">Dien in</h2>
							<v-row class="pt-3">
								<v-col cols="12" sm="4" md="3">
									<h5 class="pt-4 ml-2 pr-0">
										Minimun purchase amount
									</h5>
								</v-col>
								<v-col cols="12" sm="4" md="3" class="pt-2">
									<v-text-field
										suffix="$"
										dense
										outlined
									></v-text-field>
								</v-col>
							</v-row>
							<v-row>
								<v-col cols="12" sm="4" md="3">
									<h5 class="pt-3 ml-2 pr-0">
										Maximun purchase amount
									</h5>
								</v-col>
								<v-col cols="12" sm="4" md="3" class="pt-2">
									<v-text-field
										suffix="$"
										dense
										outlined
									></v-text-field>
								</v-col>
							</v-row>
						</v-flex>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-flex xs12 md12 class="pt-1 ml-3">
							<v-checkbox
								label="Accept Per-orders"
								color="primary"
								value="primary"
							></v-checkbox>
						</v-flex>
					</v-card-actions>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	export default {
		data() {
			return {
				ex8: "primary",
			};
		},
	};
</script>